import React from 'react';
import { render } from 'react-dom';
import InfiniteCalendar, {
	Calendar,
	defaultMultipleDateInterpolation,
	withMultipleDates,
} from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css'; // only needs to be imported once
import { getWeek, getDateFromDayByWeek } from '../Common/common';

class CalendarWithMultiDates extends React.Component {
	constructor(props) {
		super(props);

		this.InfiniteCalendarComponent = withMultipleDates(Calendar);
	}

	handleSelect = (event) => {
		let tempSpecifiedDate = [...this.props.specified_dates];
		let tempSpecifiedByWeek = [...this.props.specified_by_week];

		let selectedDate = event;

		if (findIndexInArray(tempSpecifiedDate, selectedDate) >= 0) {
			tempSpecifiedDate.splice(findIndexInArray(tempSpecifiedDate, selectedDate), 1);
			tempSpecifiedByWeek.push(selectedDate);
		} else if (findIndexInArray(tempSpecifiedByWeek, selectedDate) >= 0) {
			tempSpecifiedByWeek.splice(findIndexInArray(tempSpecifiedByWeek, selectedDate), 1);
		} else {
			tempSpecifiedDate.push(selectedDate);
		}

		this.props.handleChangeDate(tempSpecifiedDate, tempSpecifiedByWeek);
	}

	handleMultipleDateCombine = (date, selected) => {
		this.display_specified_dates = this.getDisplaySpecifiedDate();
		this.display_specified_by_week = this.getDisplaySpecifiedByWeek();

		return this.getDisplaySpecifiedDate().concat(this.getDisplaySpecifiedByWeek());
	}

	getDisplaySpecifiedDate = () => {
		let temp_specified_dates = [...this.props.specified_dates];

		for (let i in this.props.specified_dates) {
			let temp_date = new Date(JSON.parse(JSON.stringify(this.props.specified_dates[i])));
			let display_date = new Date(temp_date.getFullYear() - 1, temp_date.getMonth(), temp_date.getDate());
			temp_specified_dates.push(display_date);
			//temp_date = new Date(temp_date);
			display_date = new Date(temp_date.getFullYear() + 1, temp_date.getMonth(), temp_date.getDate());
			temp_specified_dates.push(display_date);

		}

		return temp_specified_dates;
	}

	getDisplaySpecifiedByWeek = () => {
		let temp_specified_by_week = [...this.props.specified_by_week];

		for (let i in this.props.specified_by_week) {
			let temp_date = new Date(this.props.specified_by_week[i]);
			let day = temp_date.getDay();
			let week = getWeek(temp_date);
			let month = temp_date.getMonth();

			let prev_year = new Date(temp_date.getFullYear() - 1, month, temp_date.getDate());
			let newDate1 = getDateFromDayByWeek(day, week, month, prev_year);
			temp_specified_by_week.push(newDate1);

			let next_year = new Date(temp_date.getFullYear() + 1, month, temp_date.getDate());
			let newDate2 = getDateFromDayByWeek(day, week, month, next_year);
			temp_specified_by_week.push(newDate2);
		}
		return temp_specified_by_week;
	}

	render() {
		var style = {
			position: 'relative',
		};

		style = Object.assign(style, this.props.style);

		let width = 0;
		let height = 0;
		let left = 0;
		let top = 0;

		if (window.innerWidth < 800) {
			width = 250;
			height = 250;
			left = '-10px';
			top = '-400px';
		} else {
			width = 400;
			height = 300;
			left = '100px'
			top = '-400px';
		}

		if (this.props.left != null) left = this.props.left;
		if (this.props.top != null) top = this.props.top;
		if (this.props.height != null) height = this.props.height;
		if (this.props.width != null) width = this.props.width;

		let initial_dates = [...this.handleMultipleDateCombine()];

		return (
			<div style={style} >
				<div id='calendar_with_multi_dates' style={{ position: 'absolute', top: top, left: left, backgroundColor: 'white', textAlign: 'right', width: width }}>
					<InfiniteCalendar
						Component={this.InfiniteCalendarComponent}
						selected={initial_dates}
						interpolateSelection={(date, selected) => this.handleMultipleDateCombine(date, selected)}

						rowHeight={50}
						layout={'portrait'}
						width={'100%'}
						height={height}
						keyboardSupport={false}
						autoFocus={false}
						displayOptions={{
							showHeader: false
						}}
						max={this.max_date}
						onSelect={(event) => this.handleSelect(event)}

						theme={{
							selectionColor: date => {
								date = new Date(date);
								date = new Date(date.setHours(0, 0, 0));
								if (findIndexInArray(this.display_specified_by_week, date) >= 0) {
									return '#2ecc71'
								} else if (findIndexInArray(this.display_specified_dates, date) >= 0) {
									return '#f1c40f'
								} else {
									return ''
								}
							},
						}}
					/>
					<div style={{ display: 'inline-block', textAlign: 'left' }}>
						<div>
							<div style={{ width: '10px', height: '10px', backgroundColor: '#f1c40f', display: 'inline-block', marginRight: '10px' }} />
							<span style={{ display: 'inline-block' }}>{this.props.receiver.getString('date_sp')}</span>
						</div>
						<div>
							<div style={{ width: '10px', height: '10px', backgroundColor: '#2ecc71', display: 'inline-block', marginRight: '10px' }} />
							<span style={{ display: 'inline-block' }}>{this.props.receiver.getString('dow_sp')}</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function findIndexInArray(array, value) {
	return array.findIndex(item => {
		return item.getTime() == value.getTime()
	});
}

export default CalendarWithMultiDates;